import script from "./YandexRecaptcha.vue?vue&type=script&setup=true&lang=js"
export * from "./YandexRecaptcha.vue?vue&type=script&setup=true&lang=js"

export default script